'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIFlex from 'UIComponents/layout/UIFlex';
import withKeyboardShortcuts from 'DesignComponents/decorators/withKeyboardShortcuts';

function EditorWrapper(props) {
  const {
    children,
    className
  } = props,
        other = _objectWithoutPropertiesLoose(props, ["children", "className"]);

  const wrapperClasses = classNames('editor-wrapper', className);
  return /*#__PURE__*/_jsx(UIFlex, Object.assign({
    align: "stretch",
    className: wrapperClasses,
    direction: "column"
  }, other, {
    children: children
  }));
}

EditorWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
EditorWrapper.defaultProps = {
  children: null,
  className: ''
};
export default withKeyboardShortcuts()(EditorWrapper);